import React, { useState, useEffect, createRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useSnackbar } from "notistack";
import {
  TextField,
  Button,
  FormControl,
  Typography,
  FormGroup,
  Grid,
  Box,
  Stack,
  Card,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  Chip,
} from "@mui/material";
import RecordNotFound from "src/components/GeneralComponents/RecordNotFound";
import CustomPopoverNew from "src/components/CustomPopoverNew";
import AvatarGallery from "src/pages/UserInformation/component/imageViewOnLength";
import ConfirmationWithDescription from "src/components/ConfirmationWithDescription";
import { s3baseUrl } from "src/config/config";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import jsPDF from "jspdf";

export default function UpdateQueList({
  questions,
  setQuestions,
  complateWorkBook,
  setComplateWorkBook,
  setModalChangeExe,
  practiceType,
  handleSubmit,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [templateData, setTemplateData] = useState("");
  const [openModal, setOpenModal] = useState("");
  const [signatureRefs, setSignatureRefs] = useState([]);
  const [openExerciseAlert, setOpenExerciseAlert] = useState(false);
  const [isDonwloadingPdf, setIsDonwloadingPdf] = useState(false);
  const { userInfo } = useContentSetting();

  useEffect(() => {
    setSignatureRefs(
      Array.from({ length: questions.length }, () => createRef()),
    );
  }, [questions]);

  const clearSignature = (index) => {
    if (signatureRefs[index] && signatureRefs[index].current) {
      signatureRefs[index].current.clear();
    }
    questions[index].answer = "";
    setQuestions([...questions]);
  };

  const saveSignature = (index) => {
    if (signatureRefs[index] && signatureRefs[index].current.isEmpty()) {
      return;
    }
    if (signatureRefs[index] && signatureRefs[index].current) {
      const signatureImage = signatureRefs[index].current.toDataURL();

      questions[index].answer = signatureImage;
      setQuestions([...questions]);
      enqueueSnackbar(`Signature upload`, {
        variant: "success",
      });
    }
  };

  const handleAgreeInExerciseSet = () => {
    setComplateWorkBook(false);
    setModalChangeExe(true);
    setOpenExerciseAlert(false);
  };

  const handleGeneratePdf = () => {
    setIsDonwloadingPdf(true);
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
    });

    let htmlContent = `
    <div class="text-dark generating-pdf" style="font-family: Arial; padding: 20px;">
      <div class="d-flex justify-content-center" style="display: flex; justify-content: center;">
        <img src="${logo_main}" alt="Logo" class="logo-dd" style="width: 150px; height: auto;" />
      </div>
      <div class="text-center font-weight-bold mb-4" style="text-align: center; font-weight: bold; margin-bottom: 20px; font-size: 12px; margin-top: 18px;">
        ${userInfo?.first_name || ""} ${userInfo?.last_name || ""} (${
      userInfo?.email || ""
    })
      </div>
  `;

    questions.forEach((item, index) => {
      htmlContent += `
        <div style="${
          index > 0 ? "margin-top: 15px;" : ""
        } page-break-inside: avoid;">
          <h3 style="font-weight: 700; font-size: 13px; margin: 0 0 8px 0;">
            Q${index + 1}. ${item?.title || ""}
          </h3>
      `;

      if (item?.type === "multiple_choice") {
        item?.options?.forEach((option) => {
          const isChecked = item.answer === option;
          htmlContent += `
            <div style="margin: 8px 0; display: flex; align-items: center;">
              <input 
                type="radio" 
                ${isChecked ? "checked" : ""}
                style="
                  width: 12px;
                  height: 12px;
                  margin-right: 8px;
                  margin-top: 10px;
                  accent-color: #333;
                "
                disabled
              />
              <span style="font-size: 12px;">
                ${option}
              </span>
            </div>
          `;
        });
      } else if (item?.type === "multiple_select") {
        item?.options?.forEach((option) => {
          const isChecked = item.multiple_answers?.includes(option);
          htmlContent += `
            <div style="margin: 8px 0; display: flex; align-items: center;">
              <input 
                type="checkbox" 
                ${isChecked ? "checked" : ""}
                style="
                  width: 12px;
                  height: 12px;
                  margin-right: 8px;
                  margin-top: 10px;
                  accent-color: #333;
                "
                disabled
              />
              <span style="font-size: 12px;">
                ${option}
              </span>
            </div>
          `;
        });
      } else if (item?.type === "free_text") {
        htmlContent += `
            <p style="font-size: 12px; margin-top: 10px; ">
              <b><i>Answer:</i></b> ${item?.answer || ""}
            </p>
        `;
      } else if (item?.type === "text_with_link") {
        htmlContent += `
          <div style="margin-top: 10px;">
            <p style="font-size: 12px;">
              <b>${item.button_text} :</b> 
              <span style="color: #0066cc;">
                 ${item.button_link}
              </span>
            </p>
            <p style="font-size: 12px; margin: 5px 0;">
              <b><i>Answer:</i></b> ${item?.answer || ""}
            </p>
          </div>
        `;
      } else if (item?.type === "signature") {
        htmlContent += `
          <div style="margin-top: 10px;">
            ${
              item?.answer
                ? `<img src="${item.answer}" alt="Signature" style="max-width: 300px; height: auto; " />`
                : `<div style="margin-bottom: 45px;"></div>`
            }
          </div>
        `;
      } else if (item?.type === "image") {
        htmlContent += `<div style="margin-top: 15px;">`;
        if (item?.multiple_answers?.length > 0) {
          htmlContent += `<div style="display: flex; flex-wrap: wrap; gap: 10px;">`;
          item.multiple_answers.forEach((imgUrl, idx) => {
            htmlContent += `
                <img 
                  src="${s3baseUrl + imgUrl}?${new Date().getTime()}"
                  alt="Image ${idx + 1}"
                  style="max-width: 120px; max-height: 120px; display: block;"
                  crossorigin="anonymous"
                />
            `;
          });
          htmlContent += `</div>`;
        } else {
          htmlContent += `<div style="margin-bottom: 45px;"></div>`;
        }
        htmlContent += `</div>`;
      }

      htmlContent += `</div>`;
    });

    htmlContent += `</div>`;

    doc.html(htmlContent, {
      margin: [10, 15, 10, 15],
      autoPaging: "text",
      html2canvas: {
        scale: 0.75,
        allowTaint: true,
        useCORS: true,
        logging: true,
      },
      callback: (doc) => {
        doc.save("questionnaire.pdf");
        setIsDonwloadingPdf(false);
      },
    });
  };

  const handleChangeComplete = (e) => {
    const { checked } = e.target;
    let noAnswer = false;
    let question = [];

    const answers = [...questions];

    answers.some((item, i) => {
      if (item?.type === "image") {
        if (
          item?.required &&
          item?.multiple_answers?.length !== item?.options_count
        ) {
          question.push(i + 1);
          enqueueSnackbar(`Please upload all images in Question:${i + 1}`, {
            variant: "error",
          });
          noAnswer = true;
          return true;
        } else if (item?.required) {
          for (let j = 0; j < item?.options_count; j++) {
            if (!item?.multiple_answers[j]) {
              question.push(i + 1);
              enqueueSnackbar(`Please upload all images in Question:${i + 1}`, {
                variant: "error",
              });
              noAnswer = true;
              return true;
            }
          }
        }
      } else if (
        item?.required &&
        item?.type === "multiple_select" &&
        (!Array.isArray(item?.multiple_answers) ||
          item.multiple_answers.length === 0)
      ) {
        noAnswer = true;
        enqueueSnackbar(`Please answer the Question:${i + 1}`, {
          variant: "error",
        });
        return true;
      } else if (
        [
          "free_text",
          "text_with_link",
          "multiple_choice",
          "signature",
        ].includes(item?.type?.toLowerCase()) &&
        item?.required &&
        !item?.answer?.toString().trim()
      ) {
        noAnswer = true;
        enqueueSnackbar(`Please answer the Question:${i + 1}`, {
          variant: "error",
        });
        return true;
      }
      return false;
    });

    if (!noAnswer) {
      if (!checked && complateWorkBook) {
        setComplateWorkBook(checked);
        setOpenExerciseAlert(true);
        return;
      }

      setComplateWorkBook(checked);
      setModalChangeExe(true);
      if (checked) {
        handleSubmit(true, checked);
      }
    }
  };

  const handleChangeText = (e, index) => {
    questions[index].answer = e.target.value;
    setQuestions([...questions]);
  };

  return (
    <div className="container">
      <>
        <ConfirmationWithDescription
          open={openExerciseAlert}
          setOpen={setOpenExerciseAlert}
          title={"Are you sure you want to take this action?"}
          descriotion={`If you uncheck, your points or coins allocated for this ${practiceType} will be deducted.`}
          handleAgree={handleAgreeInExerciseSet}
          isJustForOk={false}
        />
        {questions.length > 0 && (
          <div className="col-12 text-end">
            <button
              className="small-contained-button mb-3"
              onClick={(e) => {
                handleGeneratePdf();
              }}
              disabled={isDonwloadingPdf}
            >
              {isDonwloadingPdf ? "Downloading..." : "Download PDF"}
            </button>
          </div>
        )}

        <Stack
          direction="column"
          alignItems="center"
          spacing={1.5}
          justifyContent="space-between"
          mb={4.5}
        >
          {questions.length > 0 ? (
            questions.map((item, index) => {
              if (!signatureRefs[index]) {
                signatureRefs[index] = createRef();
              }

              return (
                <Card
                  className="w-100"
                  sx={{
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    mb: 1,
                    width: { sm: "100%", md: "100%" },
                    margin: "auto",
                    p: 2,
                    backgroundColor: "",
                    borderRadius: 0.5,

                    position: "relative",
                  }}
                >
                  {item?.required && (
                    <Chip
                      label={"Required"}
                      variant="contained"
                      color={"error"}
                      sx={{
                        fontSize: "10px",
                        height: "auto",
                        width: "auto",
                        position: "absolute",
                        top: 8,
                        left: 16,
                      }}
                    />
                  )}
                  <Box sx={{ width: "100%", margin: "auto" }} margin={0}>
                    <Grid
                      container
                      rowSpacing={0}
                      columnSpacing={{ xs: 0, sm: 0, md: 2 }}
                      mt={1}
                    >
                      <Grid item md={12} xs={12}>
                        <div className="d-flex align-items-center mb-2">
                          <div className="">
                            <Typography
                              sx={{ fontWeight: "900", fontSize: 16, mr: 1 }}
                            >
                              Q{index + 1}.
                            </Typography>
                          </div>
                          <div>
                            <Typography
                              variant="body1"
                              sx={{ fontSize: 14, mr: 1 }}
                            >
                              {item?.title}
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                      {item?.type == "multiple_choice" ? (
                        <Grid item md={12} xs={12}>
                          <FormControl>
                            <RadioGroup
                              aria-labelledby="demo-controlled-radio-buttons-group"
                              name="controlled-radio-buttons-group"
                              value={item?.answer}
                              onChange={(e) => {
                                questions[index].answer = e.target.value;
                                setQuestions([...questions]);
                              }}
                            >
                              {item?.options.map((item) => {
                                return (
                                  <Grid item md={12}>
                                    <FormControlLabel
                                      value={item}
                                      control={<Radio />}
                                      label={item}
                                    />
                                  </Grid>
                                );
                              })}{" "}
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      ) : item?.type == "multiple_select" ? (
                        <Grid item md={12} xs={12}>
                          <FormControl>
                            <FormGroup>
                              {item?.options.map((option) => (
                                <Grid item md={12} key={option}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={(
                                          questions[index]?.multiple_answers ||
                                          []
                                        )?.includes(option)}
                                        onChange={(e) => {
                                          const checked = e.target.checked;
                                          const existingAnswers =
                                            questions[index]
                                              ?.multiple_answers || [];

                                          const updatedAnswers = checked
                                            ? [...existingAnswers, option]
                                            : existingAnswers.filter(
                                                (value) => value !== option,
                                              );

                                          const updatedQuestions = [
                                            ...questions,
                                          ];
                                          updatedQuestions[index] = {
                                            ...updatedQuestions[index],
                                            multiple_answers: updatedAnswers,
                                          };

                                          setQuestions(updatedQuestions);
                                        }}
                                      />
                                    }
                                    label={option}
                                  />
                                </Grid>
                              ))}
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      ) : item?.type == "image" ? (
                        <Grid item md={12} xs={12}>
                          <div className="d-flex align-items-center flex-wrap mb-2">
                            <div className="">
                              <Typography
                                sx={{
                                  fontWeight: "500",
                                  fontSize: 14,
                                  mr: 1,
                                }}
                              >
                                {item?.options[0]}
                              </Typography>
                            </div>
                            <AvatarGallery
                              length={item?.options_count}
                              Index={index}
                              questions={questions}
                              Image={item?.answer}
                              multiple_answers={item.multiple_answers}
                              setQuestions={setQuestions}
                            />
                          </div>
                        </Grid>
                      ) : item?.type == "free_text" ? (
                        <Grid item md={12} xs={12}>
                          <TextField
                            id="outlined-multiline-static"
                            label="Answer"
                            multiline
                            rows={4}
                            value={item?.answer}
                            sx={{ width: "100%" }}
                            onChange={(e) => handleChangeText(e, index)}
                          />
                        </Grid>
                      ) : item?.type == "text_with_link" ? (
                        <>
                          <Grid item md={12} xs={12}>
                            <Button
                              variant="contained"
                              type="button"
                              className="my-3"
                              onClick={() => {
                                if (item.button_link) {
                                  setTemplateData(item.button_link);
                                  setOpenModal(true);
                                }
                              }}
                            >
                              {item.button_text}
                            </Button>
                          </Grid>
                          <Grid item md={12} xs={12}>
                            <TextField
                              id="outlined-multiline-static"
                              label="Answer"
                              multiline
                              rows={4}
                              value={item?.answer}
                              sx={{ width: "100%" }}
                              onChange={(e) => handleChangeText(e, index)}
                            />
                          </Grid>
                        </>
                      ) : (
                        item?.type == "signature" && (
                          <Grid item md={12} xs={12}>
                            <div>
                              {item?.answer ? (
                                <img
                                  key={index}
                                  src={item?.answer}
                                  alt={`Signature ${index + 1}`}
                                  style={{
                                    border: "1px solid #000",
                                    borderRadius: "10px",
                                    width: "100%",
                                    height: "110px",
                                    marginBottom: "6px",
                                  }}
                                />
                              ) : (
                                <SignatureCanvas
                                  ref={signatureRefs[index]}
                                  canvasProps={{
                                    className: "signature-canvas",
                                    style: {
                                      width: "100%",
                                      height: "110px",
                                      border: "1px solid #000",
                                      borderRadius: "10px",
                                    },
                                  }}
                                  backgroundColor="white"
                                  penColor="black"
                                />
                              )}

                              <div className="text-end">
                                <Button
                                  variant="contained"
                                  size="small"
                                  className="me-1"
                                  sx={{
                                    backgroundColor: "#aeaeae",
                                    "&:hover": {
                                      backgroundColor: "#aeaeae",
                                    },
                                  }}
                                  onClick={() => clearSignature(index)}
                                >
                                  Clear
                                </Button>
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => saveSignature(index)}
                                >
                                  Save
                                </Button>
                              </div>
                            </div>
                          </Grid>
                        )
                      )}
                    </Grid>
                  </Box>
                </Card>
              );
            })
          ) : (
            <RecordNotFound title="Questions Not Found" />
          )}
        </Stack>
        <div className="d-flex justify-content-end mt-3">
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ p: "3px" }}
                  checked={complateWorkBook ? complateWorkBook : false}
                  onChange={(e) => handleChangeComplete(e)}
                />
              }
              label="Mark as Complete"
            />
          </FormGroup>
        </div>
        <CustomPopoverNew
          isOpenPop={openModal}
          isClosePop={setOpenModal}
          title={""}
          componentToPassDown={
            <div>
              <iframe
                src={templateData}
                className="w-100 border-none"
                style={{
                  height: "100vh",
                }}
              />
            </div>
          }
        />
      </>
    </div>
  );
}
